import { Component, Input, OnInit } from '@angular/core';
import { CommonTypesDataListsDetailsXMLSection } from 'src/app/model/section/common-types-datalists-details-xml-section';

@Component({
  selector: 'app-common-types-datalists-details-xml-section',
  templateUrl: './common-types-datalists-details-xml-section.component.html',
  styleUrls: ['./common-types-datalists-details-xml-section.component.scss']
})
export class CommonTypesDatalistsDetailsXmlSectionComponent implements OnInit {
  @Input() isSubSection = false;
  @Input() commonTypesDataListsDetailsXMLSections: CommonTypesDataListsDetailsXMLSection[] = [];
  constructor() {}

  ngOnInit(): void {}
}
